import React, { PropTypes } from 'react';
import ImageSamplesUpload from 'registration/creative/containers/image_samples_upload';
import WritingSamplesUpload from 'registration/creative/containers/writing_samples_upload';
import ModalDialog from 'common/components/modal/modal_dialog';

/**
 * Work samples upload modal.
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
const WorkSamplesUpload = ({ type, onClose, group }) => {
  const headerText = (
    type === "image"? `Add 3 ${group.name} Work Samples` : `Questions for ${group.name} Category`
  );
  const Component = type === "image"? ImageSamplesUpload : WritingSamplesUpload;

  return (
    <ModalDialog modalOpen={true} dialogClasses={`work-samples-modal ${type}`}
      closeAction={onClose} contentClasses={type === "image"? "wide" : ""}
      modalHeader={headerText}>
      <Component group={group} onDone={onClose} />
    </ModalDialog>
  );
}

WorkSamplesUpload.propTypes = {
  group: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired
};

export default WorkSamplesUpload;



// WEBPACK FOOTER //
// ./registration/creative/components/work_samples_upload.jsx